import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check, ArrowRight, Scale, FileText, ShieldCheck, Users, KeyRound, Globe } from "lucide-react";

const CATEGORIES = {
  fiscale: { label: "Servizi Fiscali", color: "text-labor-olive", icon: FileText, desc: "Dichiarazioni, ISEE, successioni." },
  patronato: { label: "Servizi Patronato", color: "text-labor-terracotta", icon: Users, desc: "INPS, pensioni, invalidità, disoccupazione." },
  tesserati: { label: "Riservato Tesserati", color: "text-labor-warning", icon: KeyRound, desc: "Servizi extra per soci Labor." },
  legale: { label: "Area Legale", color: "text-labor-ink", icon: Scale, desc: "Consulenze con avvocato · mercoledì pomeriggio." },
  immigrazione: { label: "Immigrazione", color: "text-labor-olive", icon: Globe, desc: "Permessi di soggiorno e richiesta cittadinanza italiana." },
};

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data.services)); }, []);

  const grouped = services.reduce((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s);
    return acc;
  }, {});

  const order = ["fiscale", "patronato", "immigrazione", "tesserati", "legale"];

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-widest text-labor-muted">I nostri servizi</div>
        <h1 className="font-display text-5xl md:text-6xl mt-2 mb-4">Tutto quello di cui hai bisogno.</h1>
        <p className="text-lg text-labor-muted">Ogni pratica è seguita personalmente. Trovi qui l'elenco completo dei servizi con i documenti necessari.</p>
      </div>

      {order.filter(cat => grouped[cat]).map((cat) => {
        const meta = CATEGORIES[cat];
        const items = grouped[cat];
        const isLegal = cat === "legale";
        return (
          <div key={cat} className={`mt-14 ${isLegal ? "paper-card p-8 md:p-10 bg-labor-ink text-white" : ""}`}>
            <div className="flex items-start gap-4 mb-6">
              <meta.icon className={`w-10 h-10 ${isLegal ? "text-white" : meta.color}`} strokeWidth={1.4} />
              <div>
                <h2 className={`font-display text-3xl ${isLegal ? "text-white" : meta.color}`}>{meta.label}</h2>
                <div className={`text-sm mt-1 ${isLegal ? "opacity-80" : "text-labor-muted"}`}>{meta.desc}</div>
              </div>
            </div>
            <div className="grid md:grid-cols-2 gap-5">
              {items.map((s) => (
                <div key={s.id} data-testid={`service-card-${s.id}`} className={`p-7 ${isLegal ? "bg-white text-labor-ink" : "paper-card"}`}>
                  <h3 className="font-display text-2xl mb-1">{s.name}</h3>
                  <div className="text-xs uppercase tracking-widest text-labor-muted mb-4">
                    Durata: {s.duration} min {s.tesserati_only && "· Solo tesserati"} {s.lawyer_only && "· Solo mer. 15-19"}
                  </div>
                  <div className="text-sm font-semibold text-labor-ink mb-2">Documenti da portare:</div>
                  <ul className="space-y-1.5 mb-5">
                    {s.docs.map((d, i) => (
                      <li key={i} className="flex items-start gap-2 text-[15px] text-labor-muted">
                        <Check className="w-4 h-4 mt-1 text-labor-olive flex-shrink-0" /> <span>{d}</span>
                      </li>
                    ))}
                  </ul>
                  <Link
                    to={`/prenota?service=${s.id}`}
                    data-testid={`service-book-${s.id}`}
                    className="inline-flex items-center gap-2 text-labor-olive font-semibold hover:text-labor-terracotta"
                  >
                    Prenota per questo servizio <ArrowRight className="w-4 h-4" />
                  </Link>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
